import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faMinusSquare } from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from '../../redux/store';
import { setDialogMode, openDialog, selectInformation } from '../../redux/slices/manageTradingCompanyInformation';
import type { ICellRendererParams } from 'ag-grid-community';
import type { InformationType } from '../../types/information';

const ActionsManageTradingCompanyInformation = (props: ICellRendererParams) => {
  const dispatch = useDispatch();
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [isDeletable, setIsDeletable] = useState<boolean>(false);
  const data: InformationType = props.data;

  // SIDE EFFECT
  // ================================================================================

  /**
   * 確認用
   */
  // useEffect(() => {
  //   console.log(data);
  // }, []);

  // 編集可能な状態にする
  useEffect(() => {
    setIsEditable(true);
    setIsDeletable(true);
  }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * Editボタンを押した時
   */
  const handleUpdateRow = (): void => {
    // console.log(props)
    if (isEditable) {
      dispatch(selectInformation(data));
      dispatch(setDialogMode('UPDATE'));
      dispatch(openDialog());
    }
  };

  /**
   * Deleteボタンを押した時
   */
  const handleDeleteRow = (): void => {
    // console.log(props)
    if (isDeletable) {
      dispatch(selectInformation(data));
      dispatch(setDialogMode('DELETE'));
      dispatch(openDialog());
    }
  };

  // VIEW
  // ================================================================================

  return (
    <>
      <div id="editInformations">
        <>
          <FontAwesomeIcon
            className="mr-3"
            icon={faEdit}
            size="lg"
            color={isEditable ? '#007bff' : '#ccc'}
            onClick={handleUpdateRow}
            style={isEditable ? { cursor: 'pointer' } : { cursor: 'default' }}
          />
          <FontAwesomeIcon icon={faMinusSquare} size="lg" color={isDeletable ? '#c4183c' : '#ccc'} onClick={handleDeleteRow} style={isDeletable ? { cursor: 'pointer' } : { cursor: 'default' }} />
        </>
      </div>
    </>
  );
};

export default ActionsManageTradingCompanyInformation;
